<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="section">
    <div class="header">
      <span class="left">
        {{'SHIPMENTDETAILS.shipmentId' | translate}} #{{shipment.unique_code}} | {{shipment.shipment_status}}
      </span>

      <span class="right" style="margin-right: 15px; display: inline-flex;">
        {{shipment.created_at}}
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </span>

    </div>
    <div class="body">
      <div class="body-tabs">
        <mat-grid-list [cols]="grid_tiles" rowHeight="2:1">
          <mat-grid-tile [ngClass]="{'selected' : tabIndex==0}" (click)='switchTab(0)'>
            <span>{{'SHIPMENTDETAILS.orderDetails' | translate}}</span>
          </mat-grid-tile>
          <mat-grid-tile [ngClass]="{'selected' : tabIndex==8}" (click)='switchTab(8)'>
            <span>{{'SHIPMENTDETAILS.activityTimeline' | translate}}</span>
          </mat-grid-tile>
          <mat-grid-tile [ngClass]="{'selected' : tabIndex==2}" (click)='switchTab(2)'>
            <span>{{'SHIPMENTDETAILS.pickup' | translate}}</span>
          </mat-grid-tile>
          <mat-grid-tile [ngClass]="{'selected' : tabIndex==3}" (click)='switchTab(3)'>
            <span>{{'SHIPMENTDETAILS.delivery' | translate}}</span>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="!isCarrierShipment" [ngClass]="{'selected' : tabIndex==6}"
            (click)='switchTab(6); getFreightInvoices(shipment._id);'>
            <span>{{'SHIPMENTDETAILS.freight' | translate}}</span>
          </mat-grid-tile>
          <mat-grid-tile [ngClass]="{'selected' : tabIndex==4}" (click)='switchTab(4)'>
            <span>{{'SHIPMENTDETAILS.lr' | translate}}</span>
          </mat-grid-tile>
          <!-- <mat-grid-tile [ngClass]="{'selected' : tabIndex==5}" (click)='switchTab(5);'>
            <span>{{'SHIPMENTDETAILS.mapPath' | translate}}</span>
          </mat-grid-tile> -->
          <mat-grid-tile *ngIf="showChart" [ngClass]="{'selected' : tabIndex==7}" (click)='switchTab(7);'>
            <span>{{'SHIPMENTDETAILS.chart' | translate}}</span>
          </mat-grid-tile>
        </mat-grid-list>

      </div>
      <div class="body-section" [hidden]="tabIndex!=7">
        <div echarts [options]="temperatureGraph" class="demo-chart" *ngIf="chartData.length;else noTempData"></div>
        <div class="temp-details" *ngIf="chartData.length">
          <div class="labels" *ngFor="let shipment of shipment_data">
            <div class="item" *ngIf="shipment.yAxis">{{shipment.name }}: {{shipment.yAxis}} °C</div>
          </div>
        </div>
        <ng-template #noTempData>
          <div class="nodata">{{'SHIPMENTDETAILS.noTemperature' | translate}}</div>
        </ng-template>
      </div>

      <div class="body-section" [hidden]="tabIndex!=8">
        <div class="customStepper">
          <div class="steps" *ngFor="let step of shipment.trails;let i = index">
            <div class="stepSection">
              <div class="leftSide">
                <span class="dateTime dateOnly" *ngIf="step.showDate">
                  {{step.dateOnly}} |
                </span>
                <span class="dateTime timeOnly">
                  {{step.timeOnly}}
                </span>
              </div>
              <div class="rightSide">
                <div class="stepHeader">
                  <div class="stepIcon">
                    <i *ngIf="step.driver_location.length" class="material-icons" (click)="openModal(step);">
                      room
                    </i>
                    <span *ngIf="!step.driver_location.length"> {{step.driver_loc}} </span>
                  </div>
                  <div class="label">
                    <span> {{step.user}} </span>
                    <span style="font-size: 12px;"> - {{step.user_type}} </span>
                  </div>
                </div>
                <div class="stepContent">
                  <div class="comment"> {{step.comment}} </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="body-section" [hidden]="tabIndex!=0">
        <div style="height:30px; margin: 5px;width: 85%;float: left;">
          <label class="left" style="font-size: 14px; ">{{'SHIPMENTDETAILS.shipper' | translate}}: </label>
          <span class="shipper" style=" font-weight: bold;text-overflow: ellipsis;float: left;width: 700px;margin-left: 10px;text-align: left;
            display: inline-block;white-space: nowrap;overflow: hidden;font-size: 14px;">{{shipment.shipper}}</span>
        </div>
        <div class="oin">
          <label style="font-size: 14px;">{{'SHIPMENTDETAILS.oin' | translate}}:
            <span>{{shipment.oin}}</span>
          </label>
        </div>
        <div class="loc-tabs">
          <mat-grid-list cols="2">
            <mat-grid-tile style="border: 1px solid #e2e1e1; box-shadow:1px 2px 2px #d7d5d5;">
              <ul>
                <li class="loc-tile" *ngFor="let item of shipment.pickups; let i = index">
                  <span class="left">
                    <label class="pick-icon">P{{i+1}}</label>
                    <!-- <img class="logo" src="assets/icon-plus.svg" alt=""> -->
                  </span>
                  <span class="left" style="margin-left: 10px; font-weight: bold;width: 300px;">
                    {{item.location.name}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 420px;">
                    {{item.location.area}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="i==0">
                    <strong>
                      {{'SHIPMENTDETAILS.pickDateTime' | translate}} : {{shipment.scheduledPickDate}}
                    </strong>
                  </span>
                  
                  <div style="line-height: 11px;">
                    <div  style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="item.location.contact_name && item.location.contact_name.length">
                      <strong *ngIf="item.location.contact_name">
                        Contact Name : {{item.location.contact_name}}
                      </strong>
                    </div>
                    <div style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="item.location.mobile && item.location.mobile.length">
                      <strong *ngIf="item.location.mobile">
                        Contact Mobile : {{item.location.mobile}}
                      </strong>
                    </div>
                  </div>
                  <span *ngIf="do_number && do_number.length"
                class="left" style="margin-left: 30px;width: 300px;padding: 5px 0px;">
                  DO Number : {{do_number}}
                </span>
                </li>
              </ul>
            </mat-grid-tile>
            <mat-grid-tile style="border: 1px solid #e2e1e1; box-shadow:1px 2px 2px #d7d5d5;">
              <ul>
                <li class="loc-tile" *ngFor="let item of shipment.deliveries; let i = index">
                  <span class="left">
                    <label class="drop-icon">D{{i+1}}</label>
                    <!-- <img class="logo" src="assets/icon-plus.svg" alt=""> -->
                  </span>
                  <span class="left" style="margin-left: 10px; font-weight: bold;width: 300px;">
                    {{item.location.name}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;">
                    {{item.location.area}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="i==0">
                    <strong>
                      {{'SHIPMENTDETAILS.deliveryDateTime' | translate}} : {{shipment.scheduledDropDate}}
                    </strong>
                  </span>
                  <div style="line-height: 11px;">
                    <div  style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="item.location.contact_name && item.location.contact_name.length">
                      <strong *ngIf="item.location.contact_name">
                        Contact Name : {{item.location.contact_name}}
                      </strong>
                    </div>
                    <div style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="item.location.mobile && item.location.mobile.length">
                      <strong *ngIf="item.location.mobile">
                        Contact Mobile : {{item.location.mobile}}
                      </strong>
                    </div>
                  </div>
                 
                </li>
              </ul>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
        <div class="grid-table">
          <mat-grid-list cols="2" rowHeight="90px">
            <mat-grid-tile class="grid-header" [colspan]=1 [rowspan]=1>
              {{'SHIPMENTDETAILS.driverVehicleDetails' | translate}}
            </mat-grid-tile>
            <mat-grid-tile class="grid-header" [colspan]=1 [rowspan]=1>
              {{'SHIPMENTDETAILS.estimatedActual' | translate}}
            </mat-grid-tile>
            <mat-grid-tile class="grid-data" [colspan]=1 [rowspan]=1>
              <div class="grid-details">
                <span *ngIf="!shipment.driver.name" class="container">{{shipment.driver}}</span>
                <!-- <div class="submitButton">
                    <div class="button" (click)="(shipment.notAccepted && shipment.driver != 'N/A')? accept(shipment) : ';'" [ngStyle]="{'background-color':(shipment.notAccepted && shipment.driver != 'N/A')? '#58cc14':'#e6e2e2'}">
                      {{'SHIPMENTDETAILS.accept' | translate}}
                    </div>
                  </div> -->
                <span *ngIf="shipment.driver.name" class="container">{{shipment.driver.name}}</span>
                <sup style="color: #e60719;font-size: 9px;font-weight: bolder;margin-left: 6px;"
                  *ngIf="shipment.notAccepted && shipment.driver != 'N/A'">
                  Not accepted</sup>
                <br>
                <span *ngIf="shipment.driver.name" class="container">{{shipment.driver.mobile}}</span>
                <br>
                <span *ngIf="shipment.driver.name" class="container">{{shipment.driver.vehicle_type.name}}</span>
                <br>
                <span *ngIf="shipment.driver.name" class="container">{{shipment.driver.vehicle_no}}</span>
                <br>
              </div>
              <div class="vertical-border" style="border-left: 3px solid #b9b4b4;
              width: 38%;
              height: 126px;"></div>
              <div class="grid-details">
                <span class="container" style="position: relative;right: 16px;margin-right: 13px;"><label
                    class="cont-data">{{'SHIPMENTDETAILS.SO' |
                    translate}} :</label>
                  {{shipment.order && shipment.order.sale_order?shipment.order.sale_order : 'N/A' }}
                </span>
                <span class="container" style="position: relative;display: flex;right: 16px;margin-right: 13px;"><label
                  class="cont-data">{{'SHIPMENTDETAILS.PO' |
                  translate}} :</label>
                <div *ngIf="purchase_orders && purchase_orders.length">
                  <span *ngFor="let item of purchase_orders; let i = index">
                    {{item.name}}<span *ngIf="purchase_orders.length > 1 && i != purchase_orders.length-1">,</span><br />
                  </span>
                </div>
                <span *ngIf="!purchase_orders.length">N/A</span>
              </span>
                <span class="container" style="position: relative;display: flex;right: 16px;margin-right: 13px;"><label
                  class="cont-data">{{'SHIPMENTDETAILS.segmentation' |
                  translate}} :</label>
                <div *ngIf="segmentations.length">
                  <span *ngFor="let item of segmentations;let i = index">
                    {{item.name}}<span *ngIf="segmentations.length > 1 && i != segmentations.length-1">,</span><br />
                  </span>
                </div>
                <span *ngIf="!segmentations.length">N/A</span>
              </span>
              <span class="container" style="position: relative;display: flex;right: 16px;margin-right: 13px;"><label
                class="cont-data">{{'SHIPMENTDETAILS.destinationCode' |
                translate}} :</label>
              <div *ngIf="parentData.others && parentData.others.destination_code">
                <span>
                  {{parentData.others.destination_code}}
                </span>
              </div>
              <span *ngIf="parentData.others && !parentData.others.destination_code">N/A</span>
            </span>
              </div>
            </mat-grid-tile>
            <!-- <mat-grid-tile class="grid-data" [colspan]=1 [rowspan]=1>
                <div class="grid-details">
                  <div class="container">
                    <span class="cont-data">Requested Vehicle </span> :
                    <span class="cont-data" style="width: 90px !important;">{{shipment.requested_vehicle.vehicle_name}} ({{shipment.requested_vehicle.body_type}})</span>
                    <br>
                  </div>
                  <div class="container"><span class="cont-data">Assigned Vehicle </span>:
                    <span class="cont-data" style="width: 90px !important;">{{shipment.vehicle.vehicle_name}}  ({{shipment.vehicle.body_type}})</span>
                  </div>

                </div>
              </mat-grid-tile> -->
            <mat-grid-tile class="grid-data" [colspan]=1 [rowspan]=1>
              <!-- Est and act  -->
              <div class="grid-details">
                <span class="container">
                  <label class="cont-data">{{'SHIPMENTDETAILS.distance' | translate}} :</label>
                  {{ shipment.estimated.distance }} | {{shipment.actual_distance}}
                </span>
                <br>
                <span class="container">
                  <label class="cont-data">{{'SHIPMENTDETAILS.duration' | translate}} :</label>
                  {{ shipment.estimated.duration }} | {{shipment.actual_duration}}
                </span>
                <br>
                <span class="container">
                  <label class="cont-data">{{'SHIPMENTDETAILS.fare' | translate}} :
                  </label>{{currencySymbol}} {{ shipment.estimated.price }} | {{currencySymbol}} {{
                  shipment.actual.price
                  }}
                </span>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>

      </div>

      <div class="body-section" [hidden]='tabIndex!=1' style=" padding-top: 0px;overflow: auto;">
        <!-- Activity timeline tab -->
        <table *ngIf="shipment.trails && shipment.trails.length" mat-table [dataSource]="shipment.trails"
          class="activityTable">
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.user' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 60px;"> {{element.user}} </td>
          </ng-container>

          <ng-container matColumnDef="user_type">
            <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.userType' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="width: 50px; word-wrap: break-word;"> {{element.user_type}}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="activity">
              <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.activity' | translate}} </th>
              <td mat-cell *matCellDef="let element" style="width: 60px; word-wrap: break-word;"> {{element.activity}} </td>
            </ng-container> -->

          <ng-container matColumnDef="comment">
            <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.activity' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 120px; word-wrap: break-word;"> {{element.comment}}
            </td>
          </ng-container>

          <ng-container matColumnDef="driver_location">
            <th mat-header-cell *matHeaderCellDef class="customHeader" style="width: 40px;word-wrap: break-word;">
              {{'SHIPMENTDETAILS.driverLocation' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="width: 40px;">
              <span *ngIf="!element.driver_location.length">{{element.driver_loc}}</span>
              <i *ngIf="element.driver_location.length" class="material-icons"
                style="margin-top: -3px; cursor: pointer;" (click)="$event.stopPropagation();openModal(element);">
                room
              </i>
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef class="customHeader" style="word-wrap: break-word; width: 60px;">
              {{'SHIPMENTDETAILS.dateTime' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="width: 60px; word-wrap: break-word;"> {{element.date}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="trailColumns;sticky: true" style="font-weight: bold !important;"></tr>
          <tr mat-row *matRowDef="let row; columns: trailColumns;"></tr>
        </table>
        <div class="nodata" *ngIf="!shipment.trails.length">
          {{'SHIPMENTDETAILS.noActivity' | translate}}
        </div>
      </div>
      <div class="body-section" [hidden]='tabIndex!=2'>
        <mat-grid-list cols="2" rowHeight="2:1" class="pickgrid">
          <mat-grid-tile [ngClass]="{'pickSelected' : pickTab==21}" (click)="pickTab = 21;">
            <span>{{'SHIPMENTDETAILS.pickupDetails' | translate}}</span>
          </mat-grid-tile>
          <mat-grid-tile [ngClass]="{'pickSelected' : pickTab==22}" (click)="pickTab = 22;">
            <span>{{'SHIPMENTDETAILS.containerNo&Seal' | translate}}</span>
          </mat-grid-tile>
        </mat-grid-list>
        <div class="pickup-tab" *ngFor="let item of shipment.pickups; let i = index" [hidden]="pickTab!=21">
          <div class="loc-tabs">

            <mat-grid-list cols="2" rowHeight="2:1">
              <mat-grid-tile>
                <ul>
                  <span class="left">
                    <label class="pick-icon">P{{i+1}}</label>
                  </span>
                  <span class="left" style="margin-left: 10px; font-weight: bold;width: 300px;">
                    {{item.location.name}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;">
                    {{item.location.area}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="i==0">
                    <strong>
                      {{'SHIPMENTDETAILS.pickDateTime' | translate}} : {{shipment.scheduledPickDate}}
                    </strong>
                  </span>
                </ul>
              </mat-grid-tile>
              <mat-grid-tile>
                <ul>

                  <li>
                    <div class="header-date-time">
                      <div class="label" style="width: 96%; border:1px solid #ccc">
                        {{'SHIPMENTDETAILS.date_time' | translate}}
                      </div>
                    </div>
                    <div class="details-date-time" style="width: 98%; border:1px solid #ccc">
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:130px;font-weight: bold;">{{'SHIPMENTDETAILS.start' |
                          translate}} </label>: {{ toShortDateTime(item.started_at) }}</span>
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:130px;font-weight: bold;">{{'SHIPMENTDETAILS.arrival' |
                          translate}} </label>: {{ toShortDateTime(item.arrived_at)}}
                      </span>
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:130px;font-weight: bold;">{{'SHIPMENTDETAILS.loadStart' |
                          translate}} </label>: {{ item.driver_act_loading_time ?
                        toShortDateTime(item.driver_act_loading_time.start)
                        : item.driver_est_loading_time ? toShortDateTime(item.driver_est_loading_time.start) : 'N/A' }}
                      </span>
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:130px;font-weight: bold;">{{'SHIPMENTDETAILS.loadComplete' |
                          translate}}
                        </label>: {{ item.driver_act_loading_time ? toShortDateTime(item.driver_act_loading_time.end) :
                        item.driver_est_loading_time
                        ? toShortDateTime(item.driver_est_loading_time.end) : 'N/A' }}
                      </span>
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:130px;font-weight: bold;">{{'SHIPMENTDETAILS.dispatched' |
                          translate}} </label>: {{ toShortDateTime(item.finished_at) }}</span>
                      <br>
                    </div>
                    <!-- <span class="container"><label class="left" style="width:100px;font-weight: bold;position: relative; top: 3px">{{'SHIPMENTDETAILS.arrivalTime' | translate}}</label>:  
                        <input [disabled]="(enableArrival == false)? true : false" [ngStyle]="{'background-color': !enableArrival?'#e2e2e2':'#fff'}" type="text" style="width: 20%;" class="datePicker" placeholder="Date" [(ngModel)]="item.arrivalTime.date"
                    (click)="pickerArrivalDate.open()"  [matDatepicker]="pickerArrivalDate" />
                  <mat-datepicker #pickerArrivalDate (closed)="setDateTime(item.arrivalTime)"></mat-datepicker>
                  <input [disabled]="(enableArrival == false)? true : false" [ngStyle]="{'background-color': !enableArrival?'#e2e2e2':'#fff'}" style="width:20%;" type="text" placeholder="Time" class="timePicker" [(ngModel)]="item.arrivalTime.time" [ngxTimepicker]="pickerArrival">
                            <ngx-material-timepicker class="timePick" #pickerArrival (closed)="setDateTime(item.arrivalTime)"></ngx-material-timepicker>
                            <img *ngIf="!enableArrival" [hidden]="true" src="assets/icon-edit.svg" alt="" class="editTime" (click)="enableArrival = true">
                            <img *ngIf="enableArrival" [hidden]="true" src="assets/Completed.svg" alt="" class="editTime" (click)="enableArrival = false; editTime(item);">
                        </span><br> -->
                    <!-- <span class="container"><label class="left" style="width:100px;font-weight: bold;">{{'SHIPMENTDETAILS.loadingTime' | translate}}</label>:  {{ toShortDateTime(item.loading_time) }}</span><br> -->
                    <!-- <span class="container"><label class="left" style="width:100px;font-weight: bold;position: relative; top: 3px">{{'SHIPMENTDETAILS.finishTime' | translate}}</label>:  
                        <input [disabled]="(enableFinish == false)? true : false" [ngStyle]="{'background-color': !enableFinish?'#e2e2e2':'#fff'}" type="text" style="width: 20%;" class="datePicker" placeholder="Date" [(ngModel)]="item.finishTime.date"
                        (click)="pickerFinishDate.open()"  [matDatepicker]="pickerFinishDate" />
                      <mat-datepicker #pickerFinishDate (closed)="setDateTime(item.finishTime)"></mat-datepicker>
                      <input [disabled]="(enableFinish == false)? true : false" [ngStyle]="{'background-color': !enableFinish?'#e2e2e2':'#fff'}" style="width:20%;" type="text" placeholder="Time" class="timePicker" [(ngModel)]="item.finishTime.time" [ngxTimepicker]="pickerFinish">
                                <ngx-material-timepicker class="timePick" #pickerFinish (closed)="setDateTime(item.finishTime)"></ngx-material-timepicker>
                                <img *ngIf="!enableFinish" [hidden]="true" src="assets/icon-edit.svg" alt="" class="editTime" (click)="enableFinish = true">
                                <img *ngIf="enableFinish" [hidden]="true" src="assets/Completed.svg" alt="" class="editTime" (click)="enableFinish = false;editTime(item);">
                              </span> -->
                  </li>
                </ul>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
          <div class="separatorDiv">
            {{'SHIPMENTDETAILS.goods' | translate}} :
            <span *ngFor="let item of shipment.order.materials"> {{item.name}}
              <span *ngIf="shipment.order.materials.length > 1 && i != shipment.order.materials.length-1">,</span>
            </span>
          </div>
          <div class="deliveryTable">
            <table *ngIf="item.invoices.length" mat-table [dataSource]="item.invoices" class="loadTable"
              style="margin-top:0px;">

              <ng-container matColumnDef="loc">
                <th mat-header-cell *matHeaderCellDef class="customHeader"
                  style="width: 200px!important; word-wrap: break-word;"> {{'SHIPMENTDETAILS.deliveryLocation' |
                  translate}} </th>
                <td mat-cell rowspan="element.rowSpan" *matCellDef="let element; let in=index;"
                  style=" text-align: left;">
                  <span class="left">
                    <label class="drop-icon">D{{in+1}}</label>
                  </span>
                  <span class="left" style="margin-left: 30px; margin-top: -17px; font-weight: bold;width: 200px;">
                    {{element.delivery_id.location.name}}
                  </span>
                  <span class="left" style="margin-left: 30px;">
                    {{element.delivery_id.location.area}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="{{column}}" *ngFor="let column of invoiceHeaders; let i = index;">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  <!-- {{column}} -->
                  <span *ngIf="i==0">
                    {{'SHIPMENTDETAILS.invoiceNo' | translate}}
                  </span>
                  <span *ngIf="i==1">
                    {{'SHIPMENTDETAILS.value' | translate}}
                  </span>
                  <span *ngIf="i==2">
                    {{'SHIPMENTDETAILS.noOfPackages' | translate}}
                  </span>
                  <span *ngIf="i==3">
                    {{'SHIPMENTDETAILS.gross_weight' | translate}} 
                    <span *ngIf="shipment.uom || measure_unit">({{ shipment.uom || measure_unit }})</span>
                    <span *ngIf="!shipment.uom || !measure_unit">(MT)</span>
                  </span>
                  <span *ngIf="i==4">
                    {{'SHIPMENTDETAILS.net_weight' | translate}} 
                    <span *ngIf="shipment.uom || measure_unit" >({{ shipment.uom || measure_unit }})</span>
                    <span *ngIf="!shipment.uom || !measure_unit">(MT)</span>
                  </span>
                  <span *ngIf="i==5">
                    {{'SHIPMENTDETAILS.considered_weight' | translate}} 
                    <span *ngIf="shipment.uom || measure_unit">({{ shipment.uom || measure_unit }})</span>
                    <span *ngIf="!shipment.uom || !measure_unit">(MT)</span>
                  </span>
                </th>
                <td mat-cell *matCellDef="let element; let ind=index;">
                  <div class="invoiceRow" *ngFor="let inv of element.commercial_invoices; let i = index;">
                    <span *ngIf="column=='invoices'">
                      <input class="inputField" [(ngModel)]="inv.num" [disabled]="true">
                    </span>
                    <span *ngIf="column=='total_value'">
                      <input class="inputField" [(ngModel)]="inv.value" style="width: 60%;" [disabled]="true" min="0"
                        type="number">
                    </span>
                    <span *ngIf="column=='total_nop'">
                      <input class="inputField" [(ngModel)]="inv.nop" style="width: 40%;" [disabled]="true" min="0"
                        type="number">
                    </span>
                    <span *ngIf="column=='gross_weight'">
                      <input class="inputField" [(ngModel)]="inv.gross_weight" style="width: 60%;" [disabled]="true"
                        min="0" type="number">
                    </span>
                    <span *ngIf="column=='net_weight'">
                      <input class="inputField" [(ngModel)]="inv.net_weight" style="width: 60%;" [disabled]="true"
                        min="0" type="number">
                    </span>
                    <span *ngIf="column=='considered_weight'">
                      <input class="inputField" [(ngModel)]="inv.considered_weight" style="width: 60%;" [disabled]="true"
                        min="0" type="number">
                    </span>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="deliveryArrayColumns;sticky: true"
                style="font-weight: bold !important;"></tr>
              <tr mat-row (click)="showInvoices(row)"
                *matRowDef="let row; columns: deliveryArrayColumns; let i = index"></tr>
            </table>
          </div>
          <div class="docs">
            <div class="documents">
              <div class="goods">
                <div class="label" style="width: 100%;">
                  Documents
                </div>
                <div class="input">
                  <div class="gallery-box">
                    <div class="gallery" *ngIf="item.all_docs && item.all_docs.length;else noDocs">
                      <div class="thumbnail" *ngFor="let link of item.all_docs">
                        <mat-card *ngIf="link">
                          <mat-card-content>
                            <app-doc-preview [asset]="link"></app-doc-preview>
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </div>
                    <ng-template #noDocs>
                      <div>
                        No Documents Found
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="epods">
                <div class="label">
                  Signature
                </div>
                <div class="input">
                  <div class="gallery-box">
                    <div class="gallery">
                      <div class="thumbnail" *ngIf="item.shipper_signature;else noSign">
                        <!-- <mat-card > -->
                        <!-- <mat-card-content> -->
                        <img class="image" src="{{item.shipper_signature}}">
                        <!-- </mat-card-content> -->
                        <!-- </mat-card> -->
                      </div>
                    </div>
                    <ng-template #noSign>
                      <div>
                        <p>No Signature Found</p>
                      </div>
                    </ng-template>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="separatorDiv" style="border-top: solid 1px #7a3365; margin-top: 10px;"> </div>
        </div>
        <div class="containerSection" [hidden]="pickTab!=22">
          <div class="containerBody" *ngFor="let item of shipment.pickups; let i = index">
            <div class="head">
              <div class="pickupLabel">
                <label class="pick-icon">P{{i+1}}</label>
                <span class="location">{{item.location.name}}</span>
              </div>
              <div class="submitButton">
                <div class="button" (click)="requestContainerSeal(item);">
                  {{'SHIPMENTDETAILS.request' | translate}}
                </div>
              </div>
              <div class="submitButton" style="margin-right: 10px;">
                <div class="button" style="background-color: #7a3365;width: auto;"
                  (click)="uploadContainerSeal(item._id,i);">
                  {{'SHIPMENTDETAILS.upload_container#' | translate}}
                </div>
              </div>
              <div class="submitButton" style="margin-right: 10px;">
                <div class="button" style="background-color: #7a3365;width: auto;"
                  (click)="uploadContainerSeal(item._id,i);">
                  {{'SHIPMENTDETAILS.upload_seal#' | translate}}
                </div>
              </div>
              <input class="form-input" id="containerNo" accept="image/*, .pdf"
                (change)="fileChanged($event, 'containerNo')" type="file" hidden />

            </div>
            <div class="containerTable">
              <table mat-table #containTable [dataSource]="containerArray[i]">
                <ng-container matColumnDef="containerNo">
                  <th mat-header-cell *matHeaderCellDef> {{'SHIPMENTDETAILS.containerNo' | translate}} </th>
                  <td mat-cell *matCellDef="let row"> {{row.containerNo}} </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <div class="inputContainer">
                      <input type="text" placeholder="Container No" [(ngModel)]="containerSealNo[i].container">
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="sealNo">
                  <th mat-header-cell *matHeaderCellDef> {{'SHIPMENTDETAILS.sealNo' | translate}} </th>
                  <td mat-cell *matCellDef="let row"> {{row.sealNo}} </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <div class="inputContainer">
                      <input type="text" placeholder="Seal No" [(ngModel)]="containerSealNo[i].seal">
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> {{'SHIPMENTDETAILS.action' | translate}} </th>
                  <td mat-cell *matCellDef="let row">
                    <img style="width: 17px;" src="assets/icon-cancel-red.svg" alt="">
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <img style="width: 17px;" src="assets/plus.svg" alt="" (click)="addNumbers(item, i);">
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="containerColums;"></tr>
                <tr mat-row *matRowDef="let row; columns: containerColums"></tr>
                <tr mat-footer-row *matFooterRowDef="containerColums"></tr>
              </table>
            </div>
            <!-- <div class="submitButton">
                <div class="button" (click)="selectPODs(item._id);">
                    {{'SHIPMENTDETAILS.upload' | translate}}
                </div>
              </div> -->
            <div class="pictures">
              <div class="images" *ngIf="item.other_docs && item.other_docs.length;else noDocs">
                <div class="thumbnail" *ngFor="let link of item.other_docs">
                  <mat-card *ngIf="link">
                    <mat-card-content>
                      <app-doc-preview [asset]="link"></app-doc-preview>
                      <!-- <img class="image" src="{{link}}">
                            <div class="overlay">
                              <a href="{{link}}" class="icon">
                                <i class="material-icons">get_app</i>
                              </a>
                            </div> -->
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-section" [hidden]='tabIndex!=3'>
        <!-- Delivery tab -->
        <div class="delivery-tab" *ngFor="let item of shipment.deliveries; let i = index">
          <div class="loc-tabs" style="height: 100px;">

            <mat-grid-list cols="2" rowHeight="2:1">
              <mat-grid-tile>
                <ul>
                  <span class="left">
                    <label class="drop-icon">D{{i+1}}</label>
                  </span>
                  <span class="left" style="margin-left: 10px; font-weight: bold;width: 300px;">
                    {{item.location.name}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;">
                    {{item.location.area}}
                  </span>
                  <span class="left" style="margin-left: 30px;width: 300px;padding: 5px 0px;" *ngIf="i==0">
                    <strong>
                      {{'SHIPMENTDETAILS.deliveryDateTime' | translate}} : {{shipment.scheduledDropDate}}
                    </strong>
                  </span>
                </ul>
              </mat-grid-tile>
              <mat-grid-tile>
                <ul>
                  <li>
                    <div class="header-date-time">
                      <div class="label">
                        {{'SHIPMENTDETAILS.date_time' | translate}}
                      </div>
                    </div>
                    <div class="details-date-time">
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:150px;font-weight: bold;">{{'SHIPMENTDETAILS.arrival' |
                          translate}} </label>: {{ toShortDateTime(item.arrived_at) }}</span>
                      <span class="container" style="padding:5px">
                        <label class="left"
                          style="width:150px;font-weight: bold;">{{'SHIPMENTDETAILS.unloadingStartTime' | translate}}
                        </label>: {{ item.driver_act_unloading_time ?
                        toShortDateTime(item.driver_act_unloading_time.start)
                        : 'N/A' }}</span>
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:150px;font-weight: bold;">{{'SHIPMENTDETAILS.unloadingEndTime'
                          | translate}}
                        </label>: {{ item.driver_act_unloading_time ?
                        toShortDateTime(item.driver_act_unloading_time.end)
                        : 'N/A' }}</span>
                      <span class="container" style="padding:5px">
                        <label class="left" style="width:150px;font-weight: bold;">{{'SHIPMENTDETAILS.delivered' |
                          translate}} </label>: {{ toShortDateTime(item.finished_at) }}</span>
                    </div>
                  </li>
                  <!-- <li>
                      <span class="container"><label class="left" style="width:100px;font-weight: bold;">{{'SHIPMENTDETAILS.arrivalTime' | translate}}</label>:  {{ toShortDateTime(item.arrived_at) }}</span> <br>
                      <span class="container"><label class="left" style="width:100px;font-weight: bold;">{{'SHIPMENTDETAILS.unloadingTime' | translate}}</label>:  {{ toShortDateTime(item.unloading_time) }}</span> <br>
                      <span class="container"><label class="left" style="width:100px;font-weight: bold;">{{'SHIPMENTDETAILS.finishTime' | translate}}</label>:  {{ toShortDateTime(item.finished_at) }}</span> <br> -->


                  <!-- <span class="container"><label class="left" style="width:100px;font-weight: bold;position: relative; top: 3px">{{'SHIPMENTDETAILS.arrivalTime' | translate}}</label>:  
                        <input [disabled]="(enableDeliveryArrival == false)? true : false" [ngStyle]="{'background-color': !enableDeliveryArrival?'#e2e2e2':'#fff'}" type="text" style="width: 20%;" class="datePicker" placeholder="Date" [(ngModel)]="item.arrivalTime.date"
                        (click)="pickerArrivalDate.open()"  [matDatepicker]="pickerArrivalDate" />
                      <mat-datepicker #pickerArrivalDate (closed)="setDateTime(item.arrivalTime)"></mat-datepicker>
                      <input [disabled]="(enableDeliveryArrival == false)? true : false" [ngStyle]="{'background-color': !enableDeliveryArrival?'#e2e2e2':'#fff'}" style="width:20%;" type="text" placeholder="Time" class="timePicker" [(ngModel)]="item.arrivalTime.time" [ngxTimepicker]="pickerArrival">
                                <ngx-material-timepicker class="timePick" #pickerArrival (closed)="setDateTime(item.arrivalTime)"></ngx-material-timepicker>
                                <img *ngIf="!enableDeliveryArrival" [hidden]="true" src="assets/icon-edit.svg" alt="" class="editTime" (click)="enableDeliveryArrival = true">
                                <img *ngIf="enableDeliveryArrival" [hidden]="true" src="assets/Completed.svg" alt="" class="editTime" (click)="enableDeliveryArrival = false; editDeliveryTime(item);">
                            </span><br> -->
                  <!-- <span class="container"><label class="left" style="width:100px;font-weight: bold;">{{'SHIPMENTDETAILS.loadingTime' | translate}}</label>:  {{ toShortDateTime(item.loading_time) }}</span><br> -->
                  <!-- <span class="container"><label class="left" style="width:100px;font-weight: bold;position: relative; top: 3px">{{'SHIPMENTDETAILS.finishTime' | translate}}</label>:  
                            <input [disabled]="(enableDeliveryFinish == false)? true : false" [ngStyle]="{'background-color': !enableDeliveryFinish?'#e2e2e2':'#fff'}" type="text" style="width: 20%;" class="datePicker" placeholder="Date" [(ngModel)]="item.finishTime.date"
                            (click)="pickerFinishDate.open()"  [matDatepicker]="pickerFinishDate" />
                          <mat-datepicker #pickerFinishDate (closed)="setDateTime(item.finishTime)"></mat-datepicker>
                          <input [disabled]="(enableDeliveryFinish == false)? true : false" [ngStyle]="{'background-color': !enableDeliveryFinish?'#e2e2e2':'#fff'}" style="width:20%;" type="text" placeholder="Time" class="timePicker" [(ngModel)]="item.finishTime.time" [ngxTimepicker]="pickerFinish">
                                    <ngx-material-timepicker class="timePick" #pickerFinish (closed)="setDateTime(item.finishTime)"></ngx-material-timepicker>
                                    <img *ngIf="!enableDeliveryFinish" [hidden]="true" src="assets/icon-edit.svg" alt="" class="editTime" (click)="enableDeliveryFinish = true">
                                    <img *ngIf="enableDeliveryFinish" [hidden]="true" src="assets/Completed.svg" alt="" class="editTime" (click)="enableDeliveryFinish = false; editDeliveryTime(item);">
                                  </span> <br> -->
                  <!-- </li> -->
                </ul>
              </mat-grid-tile>
            </mat-grid-list>

          </div>
          <div class="epod-buttons">
            <div class="epod-label"></div>
            <div (click)="selectPODs(item._id,i);" class="button upload-epod">
              Upload EPOD
            </div>
            <div (click)="requestEPODs(item._id)" class="button request-epod">
              Request EPOD
            </div>
            <input class="form-input" id="epods" accept="image/*, .pdf" (change)="fileChanged($event, 'epods')"
              type="file" hidden />
          </div>

          <div class="invoice-details">
            <!-- <div *ngFor="let pickups of shipment.pickups; let l = index"> -->
            <div *ngIf="item.invoices && item.invoices.length;else noInvoices">
              <div *ngFor="let invoice of item.invoices; let j = index">
                <div class="icon" style="float: right;" *ngIf="j == 0 && invoice.pdf_link">
                  <!---->
                  <a href="{{invoice.pdf_link}}">
                    <!-- <img src="assets/download_link.svg" height="25" width="30" alt=""> -->
                    <mat-icon style="font-size:25px;padding:3px ;background-color: #edf0f7; color:#09337e">get_app
                    </mat-icon>
                  </a>
                </div>
                <div *ngFor="let inv of invoice.invoice;let k = index">
                  <div class="invoice">
                    <div class="goods-details">
                      <div class="goods">
                        <div class="package-detail" style="width:6%; margin:5px 2px;">
                          <div class="label">
                            <label class="pick-icon">{{invoice.p_label}}</label>
                          </div>
                        </div>
                        <div class="package-detail">
                          <div class="label">
                            <span>{{'SHIPMENTDETAILS.invoice_number' | translate}}</span>
                          </div>
                          <div class="value">
                            {{inv.num}}
                          </div>
                        </div>
                        <div class="package-detail">
                          <div class="label">
                            <span>{{'SHIPMENTDETAILS.total_packages' | translate}}</span>
                          </div>
                          <div class="value">
                            {{inv.nop}}
                          </div>
                        </div>
                        <div class="package-detail">
                          <div class="label">
                            <span>{{'SHIPMENTDETAILS.value' | translate}} ({{ currencySymbol }})</span>
                          </div>
                          <div class="value">
                            {{inv.value}}
                          </div>
                        </div>
                        <div class="package-detail">
                          <div class="label">
                            <span>{{'SHIPMENTDETAILS.gross_weight' | translate}}</span>
                            <span *ngIf="shipment.uom || measure_unit">({{ shipment.uom || measure_unit }})</span>
                          </div>
                          <div class="value">
                            {{inv.gross_weight || 'N/A'}}
                          </div>
                        </div>
                        <div class="package-detail">
                          <div class="label">
                            <span>{{'SHIPMENTDETAILS.net_weight' | translate}}</span>
                            <span *ngIf="shipment.uom || measure_unit">({{ shipment.uom || measure_unit }})</span>
                          </div>
                          <div class="value">
                            {{inv.net_weight || 'N/A'}}
                          </div>
                        </div>
                        <div class="package-detail">
                          <div class="label">
                            <span>{{'SHIPMENTDETAILS.considered_weight' | translate}}</span>
                            <span *ngIf="shipment.uom || measure_unit">({{ shipment.uom || measure_unit }})</span>
                          </div>
                          <div class="value">
                            {{inv.considered_weight || 'N/A'}}
                          </div>
                        </div>
                      </div>

                      <div class="package-status" style="border-right:none">
                        <div class="label">
                          <div class="label-text" style="float: left;padding: 4px 17px;">
                            {{'SHIPMENTDETAILS.package_status' | translate}}
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="checkbox">
                            <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.full_checked">
                              {{'SHIPMENTDETAILS.full' | translate}}</mat-checkbox>
                          </div>
                          <div class="checkbox">
                            <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.missing_checked">
                              {{'SHIPMENTDETAILS.short' | translate}}</mat-checkbox>
                          </div>
                          <div class="checkbox">
                            <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.damaged_checked">
                              {{'SHIPMENTDETAILS.damaged' | translate}}</mat-checkbox>
                          </div>
                          <div class="checkbox">
                            <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.rejected_checked">
                              {{'SHIPMENTDETAILS.rejected' | translate}}</mat-checkbox>
                          </div>
                          <div class="checkbox">
                            <mat-checkbox [disabled]="true" class="example-margin"
                              [(ngModel)]="inv.carton_damage_checked">{{'SHIPMENTDETAILS.carton_damage' | translate}}
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="packages-details" style="width:100%;">
                      <table [hidden]="inv.disable_table" mat-table [dataSource]="invoice.invoice[k].invoice_products"
                        style="width:100%;height:auto" class="invoice-table" #table>
                        <ng-container matColumnDef="header-row-first-group" [attr.hidden]="disable_subheader">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="5" class="customHeader"> </th>
                        </ng-container>
                        <ng-container matColumnDef="material">
                          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.material' |
                            translate}}
                            <br>({{'SHIPMENTDETAILS.sku' | translate}})
                          </th>
                          <td mat-cell *matCellDef="let element" style="width: 80px;">
                            <input [disabled]="!invoice.edit_enable" type="text" [(ngModel)]="element.selectedMaterial">
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="batch">
                          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.batch' |
                            translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px;">
                            <input [disabled]="!invoice.edit_enable" type="text" style="width:60px"
                              [(ngModel)]="element.batch">
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="manuf">
                          <th mat-header-cell *matHeaderCellDef class="customHeader">
                            {{'SHIPMENTDETAILS.manufactured_date' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px;">
                            <input [disabled]="!invoice.edit_enable" type="text" class="dateSelect" style="width:60px"
                              [(ngModel)]="element.MFG_date" />
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="mrp">
                          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.mrp' |
                            translate}}
                            <br>({{'SHIPMENTDETAILS.per_item' | translate}})
                          </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px;">
                            <input [disabled]="!invoice.edit_enable" type="number" style="width:60px"
                              [(ngModel)]="element.cost_per_pcs">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="no_pcs_per_case">
                          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.pcs_in_cases' |
                            translate}}
                            <br>({{'SHIPMENTDETAILS.per_case' | translate}})
                          </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px;">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:60px" [(ngModel)]="element.pcs_in_case">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="header-row-second-group">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="customHeader subheader">
                            {{'SHIPMENTDETAILS.short' | translate}} </th>
                        </ng-container>
                        <ng-container matColumnDef="cases-s">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-right:none">
                            {{'SHIPMENTDETAILS.cases' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-right:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.missing_cases">
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="pcs-s">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-left:none">
                            {{'SHIPMENTDETAILS.pcs' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-left:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.missing_pcs">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="header-row-third-group">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="customHeader subheader">
                            {{'SHIPMENTDETAILS.damaged' | translate}} </th>
                        </ng-container>
                        <ng-container matColumnDef="cases-d">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-right:none">
                            {{'SHIPMENTDETAILS.cases' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-right:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.damaged_cases">
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="pcs-d">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-left:none">
                            {{'SHIPMENTDETAILS.pcs' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-left:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.damaged_pcs">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="header-row-fourth-group">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="customHeader subheader">
                            {{'SHIPMENTDETAILS.rejected' | translate}} </th>
                        </ng-container>
                        <ng-container matColumnDef="cases-r">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-right:none">
                            {{'SHIPMENTDETAILS.cases' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-right:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.rejected_cases">
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="pcs-r">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-left:none">
                            {{'SHIPMENTDETAILS.pcs' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-left:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.rejected_pcs">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="header-row-fifth-group">
                          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="customHeader subheader">
                            {{'SHIPMENTDETAILS.carton_damage' | translate}} </th>
                        </ng-container>
                        <ng-container matColumnDef="cases-cd">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-right:none">
                            {{'SHIPMENTDETAILS.no_of_damaged' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-right:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="!invoice.edit_enable" type="number"
                              style="width:40px" [(ngModel)]="element.carton_damage">
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="penalty-cd">
                          <th mat-header-cell *matHeaderCellDef class="customHeader" style="border-left:none">
                            {{'SHIPMENTDETAILS.carton_damage_penalty' | translate}} </th>
                          <td mat-cell *matCellDef="let element" style="width: 60px; border-left:none">
                            <input oninput="validity.valid||(value=0);" [disabled]="true" type="number"
                              style="width:40px" [(ngModel)]="element.carton_damage_penalty">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="total">
                          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.total' |
                            translate}} ({{currencySymbol}})</th>
                          <td mat-cell *matCellDef="let element" style="width: 60px;">
                            {{element.total}}
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="invoice.invoice[k].subHeader"
                          [ngClass]="{'no-status':!disable_subheader,'staus-exists':disable_subheader}"></tr>
                        <tr mat-header-row *matHeaderRowDef="invoice.invoice[k].cHeader;sticky: true"
                          style="font-weight: bold !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: invoice.invoice[k].cHeader; let index = i"></tr>
                      </table>
                      <div class="comments">
                        <div class="input-area">
                          <div class="label">
                            {{'SHIPMENTDETAILS.comments' | translate}}
                          </div>
                          <div class="input">
                            <textarea [disabled]="!invoice.edit_enable" [(ngModel)]="inv.comments"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="docs">
              <div class="documents">
                <div class="goods">
                  <div class="label">
                    {{'SHIPMENTDETAILS.upload_pics' | translate}}
                  </div>
                  <div class="input">
                    <div class="gallery-box">
                      <div class="gallery" *ngIf="item.goods_pics && item.goods_pics.length;else noPics">
                        <div class="thumbnail" *ngFor="let link of item.goods_pics">
                          <mat-card *ngIf="link">
                            <mat-card-content>
                              <app-doc-preview [asset]="link"></app-doc-preview>

                              <!-- <img class="image" src="{{link}}">
                                      <div class="overlay">
                                        <span  class="icon">
                                          <i class="material-icons" style="font-size: 20px;" (click)="openNewWindow(link)">get_app</i>
                                        </span>
                                      </div> -->
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </div>
                      <ng-template #noPics>
                        <div>
                          <p>{{'SHIPMENTDETAILS.no_pictures' | translate}} </p>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="epods">
                  <div class="label">
                    {{'SHIPMENTDETAILS.epods' | translate}}
                  </div>
                  <div class="uploader">
                                <div *ngIf="item.epodUploader">
                                    {{'SHIPMENTDETAILS.uploaded_by' | translate}}: {{item.epodUploader}}
                                </div>
                            </div>
                  <div class="input">
                    <div class="gallery-box">
                      <div class="gallery" *ngIf="item.epods && item.epods.length;else noLinks">
                        <div class="thumbnail" *ngFor="let epod of item.epods">
                          <mat-card *ngIf="epod.link">
                            <mat-card-content>
                              <img
                                *ngIf="epod.extension == 'png' || epod.extension == 'jpg' || epod.extension == 'jpeg || epod.extension == 'gif"
                                class="image" src="assets/image-icon.svg">
                              <img *ngIf="epod.extension == 'pdf'" class="image" src="assets/PDF-icon.svg">
                              <img
                                *ngIf="epod.extension == 'doc' || epod.extension == 'csv' || epod.extension == 'docx' || epod.extension == 'txt' || epod.extension == 'xlsx'"
                                class="image" src="assets/Doc-icon.svg">

                              <div class="overlay">
                                <a href="{{epod.link}}" class="icon">
                                  <i class="material-icons" style="font-size: 20px;">get_app</i>
                                </a>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </div>
                      <ng-template #noLinks>
                        <div>
                          <p>{{'SHIPMENTDETAILS.no_epods' | translate}}</p>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <ng-template #noInvoices>
              <h4>{{'SHIPMENTDETAILS.no_invoices' | translate}}</h4>
            </ng-template>
          </div>
          <div class="docs">
            <div class="documents">
              <div class="goods">
                <div class="label" style="width: 100%;">
                  Documents
                </div>
                <div class="input">
                  <div class="gallery-box">
                    <div class="gallery" *ngIf="item.all_docs && item.all_docs.length;else noDocuments">
                      <div class="thumbnail" *ngFor="let link of item.all_docs">
                        <mat-card *ngIf="link">
                          <mat-card-content>
                            <app-doc-preview [asset]="link"></app-doc-preview>
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </div>
                    <ng-template #noDocuments>
                      <div>
                        No Documents Found
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="epods">
                <div class="label">
                  Signature
                </div>
                <div class="input">
                  <div class="gallery-box">
                    <div class="gallery">
                      <div class="thumbnail" *ngIf="item.signature;else noSign">
                        <!-- <mat-card > -->
                        <!-- <mat-card-content> -->
                        <img class="image" src="{{item.signature}}">
                        <!-- </mat-card-content> -->
                        <!-- </mat-card> -->
                      </div>
                    </div>
                    <ng-template #noSign>
                      <div>
                        <p>No Signature Found</p>
                      </div>
                    </ng-template>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!-- <div class="invoice-details">
              <div *ngIf="item.invoices && item.invoices.length;else noInvoices">
                <div  *ngFor="let invoice of item.invoices; let j = index">
                  <div *ngFor="let inv of invoice.invoice;let k = index">
                    <div class="invoice">
                      <div class="goods-details">
                        <div class="goods">
                          <div class="package-detail" style="width:6%; margin:5px 2px;">
                            <div class="label">
                              <label class="pick-icon">{{invoice.p_label}}</label>
                            </div>
                          </div>
                          <div class="package-detail">
                            <div class="label">
                              <span>{{'SHIPMENTDETAILS.invoice_number' | translate}}</span>
                            </div>
                            <div class="value">
                                {{inv.num}}
                            </div>
                          </div>
                          <div class="package-detail">
                            <div class="label">
                              <span>{{'SHIPMENTDETAILS.total_packages' | translate}}</span>
                            </div>
                            <div class="value">
                                {{inv.nop}}
                            </div>
                          </div>
                          <div class="package-detail">
                            <div class="label">
                              <span>{{'SHIPMENTDETAILS.value' | translate}} ({{ currencySymbol }})</span>
                            </div>
                            <div class="value">
                                {{inv.value}}
                            </div>
                          </div>
                          <div class="package-detail">
                            <div class="label">
                              <span>{{'SHIPMENTDETAILS.weight' | translate}} (kg)</span>
                            </div>
                            <div class="value">
                                {{inv.weight}}
                            </div>
                          </div>
                        </div>

                          <div class="package-status" style="border-right:none">
                          <div class="label">
                            <div class="label-text" style="float: left;padding: 4px 17px;">
                              {{'SHIPMENTDETAILS.package_status' | translate}}
                            </div>
                          </div>
                          <div class="checkbox-group">
                            <div class="checkbox">
                              <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.full_checked">{{'SHIPMENTDETAILS.full' | translate}}</mat-checkbox>
                            </div>
                            <div class="checkbox">
                              <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.missing_checked">{{'SHIPMENTDETAILS.short' | translate}}</mat-checkbox>
                            </div>
                            <div class="checkbox">
                              <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.damaged_checked">{{'SHIPMENTDETAILS.damaged' | translate}}</mat-checkbox>
                            </div>
                            <div class="checkbox">
                              <mat-checkbox [disabled]="true" class="example-margin" [(ngModel)]="inv.rejected_checked">{{'SHIPMENTDETAILS.rejected' | translate}}</mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="packages-details">
                        <div class="package-inputs">
                          <div class="inputContainer" *ngIf="inv.missing_checked">
                            <div class="package">
                              <div class="label">
                                {{'SHIPMENTDETAILS.packages_missing' | translate}}
                              </div>
                              <div class="input">
                                <span><input type="number" [disabled]="true" [min]="0" [(ngModel)]="inv.missing.nop"></span>
                              </div>
                            </div>
                            <div class="value">
                              <div class="label">
                                {{'SHIPMENTDETAILS.value' | translate}} ({{ currencySymbol }})
                              </div>
                              <div class="input">
                                <span><input type="number" [disabled]="true" [min]="0" [(ngModel)]="inv.missing.value"></span>
                              </div>
                            </div>
                          </div>
                          <div class="inputContainer" *ngIf="inv.damaged_checked">
                            <div class="package">
                              <div class="label">
                                {{'SHIPMENTDETAILS.packages_damaged' | translate}}
                              </div>
                              <div class="input">
                                <span><input type="number" [disabled]="true" [min]="0" [(ngModel)]="inv.damaged.nop"></span>
                              </div>
                            </div>
                            <div class="value">
                              <div class="label">
                                {{'SHIPMENTDETAILS.value' | translate}} ({{ currencySymbol }})
                              </div>
                              <div class="input">
                                <span><input type="number" [disabled]="true" [min]="0" [(ngModel)]="inv.damaged.value"></span>
                              </div>
                            </div>
                          </div>

                          <div class="inputContainer" *ngIf="inv.rejected_checked">
                            <div class="package">
                              <div class="label">
                                {{'SHIPMENTDETAILS.packages_rejected' | translate}}
                              </div>
                              <div class="input">
                                <span><input type="number" [disabled]="true" [min]="0" [(ngModel)]="inv.rejected.nop"></span>
                              </div>
                            </div>
                            <div class="value">
                              <div class="label">
                                {{'SHIPMENTDETAILS.value' | translate}} ({{ currencySymbol }})
                              </div>
                              <div class="input">
                                <span><input type="number" [disabled]="true" [min]="0" [(ngModel)]="inv.rejected.value"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                  </div>
                  <div class="comments">
                    <div class="input-area">
                      <div class="label">
                        {{'SHIPMENTDETAILS.comments' | translate}}
                      </div>
                      <div class="input">
                        <textarea [disabled]="true" [(ngModel)]="invoice.comments"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="docs">
                <div class="documents" >
                  <div class="goods">
                      <div class="label">
                        {{'SHIPMENTDETAILS.upload_pics' | translate}}
                      </div>
                      <div class="input">
                        <div class="gallery-box" >
                          <div class="gallery" *ngIf="item.goods_pics && item.goods_pics.length;else noPics">
                            <div class="thumbnail" *ngFor="let link of item.goods_pics">
                              <mat-card *ngIf="link">
                                <mat-card-content>
                                    <img class="image" src="{{link}}">
                                    <div class="overlay">
                                      <a href="{{link}}" class="icon">
                                        <i class="material-icons" style="font-size: 20px;">get_app</i>
                                      </a>
                                    </div>
                                </mat-card-content>
                              </mat-card>
                            </div>
                          </div>
                          <ng-template #noPics>
                            <div>
                              <p>{{'SHIPMENTDETAILS.no_pictures' | translate}} </p>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                  </div>
                  <div class="epods">
                    <div class="label">
                      {{'SHIPMENTDETAILS.epods' | translate}}
                    </div>
                    <div class="input">
                      <div class="gallery-box" >
                        <div class="gallery" *ngIf="item.epods && item.epods.length;else noLinks">
                          <div class="thumbnail" *ngFor="let link of item.epods">
                            <mat-card *ngIf="link">
                              <mat-card-content>
                                  <img class="image" src="{{link}}">
                                  <div class="overlay">
                                    <a href="{{link}}" class="icon">
                                      <i class="material-icons" style="font-size: 20px;">get_app</i>
                                    </a>
                                  </div>
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                        <ng-template #noLinks>
                          <div>
                            <p>{{'SHIPMENTDETAILS.no_epods' | translate}}</p>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noInvoices>
                <h4>{{'SHIPMENTDETAILS.no_invoices' | translate}}</h4>
              </ng-template>
            </div> -->
        </div>
      </div>
      <div class="body-section" [hidden]='tabIndex!=4'>
        <table *ngIf="shipment.lorry_receipt.length" mat-table [dataSource]="shipment.lorry_receipt" class="lrTable">
          <ng-container matColumnDef="pick">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.pick' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 80px;">
              <span class="left">
                <label class="pick-icon">P{{element.pick_info.seq}}</label>
              </span>
              {{element.pick_info.loc_name}} - {{element.pick_info.area}}
            </td>
          </ng-container>

          <ng-container matColumnDef="drop">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.delivery' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 80px;">
              <span class="left">
                <label class="drop-icon">D{{element.delivery_info.seq}}</label>
              </span>
              {{element.delivery_info.loc_name}} - {{element.delivery_info.area}}
            </td>
          </ng-container>

          <ng-container matColumnDef="lr_number">
            <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.lrNumber' | translate}}</th>
            <td mat-cell *matCellDef="let element; let i = index;" style="width: 40px; word-wrap: break-word;">
              <div *ngIf="element.CWB">
                <div *ngIf="editLRID != element._id" class="LRNumber">
                  {{(element.CWB.manual) ? element.CWB.manual : (element.CWB.custom ? element.CWB.custom:
                  element.CWB.default )}}

                  <div class="edit" style="margin-top: 4px;"
                    *ngIf="editLRID != element._id && shipment.shipment_status != 'Cancelled'">
                    <img src="assets/icon-edit.svg" style="width: 16px; cursor: pointer;"
                      (click)="editLRID = element._id; newLRValue=(element.CWB.manual) ? element.CWB.manual : (element.CWB.custom ? element.CWB.custom: element.CWB.default )" />
                  </div>
                </div>
                <div *ngIf="editLRID == element._id" class="editCWB">
                  <input [(ngModel)]="newLRValue" />
                  <div class="material-icons submitCWD" (click)="updateCWS(element._id, i)">
                    done
                  </div>
                  <div class="material-icons cancelCWDedit" (click)="editLRID = ''">
                    close
                  </div>

                </div>

                <!-- <a *ngIf="element.pdf_link" [href]="element.pdf_link" style="font-size: 10px;" download>{{'SHIPMENTDETAILS.downloadCWB' | translate}}</a> -->
                <div>
                  <a *ngIf="element.pdf_link" [href]="element.consignor_copy" style="font-size: 10px;"
                    download>{{'SHIPMENTDETAILS.downloadCWB_consignor' | translate}}</a>
                </div>
                <div>
                  <a *ngIf="element.pdf_link" [href]="element.consignee_copy" style="font-size: 10px;"
                    download>{{'SHIPMENTDETAILS.downloadCWB_consignee' | translate}}</a>
                </div>
                <div>
                  <a *ngIf="element.pdf_link" [href]="element.driver_copy" style="font-size: 10px;"
                    download>{{'SHIPMENTDETAILS.downloadCWB_driver' | translate}}</a>
                </div>
                <div>
                  <a *ngIf="element.pdf_link" [href]="element.file_copy" style="font-size: 10px;"
                    download>{{'SHIPMENTDETAILS.downloadCWB_file' | translate}}</a>
                </div>
                <div>
                  <a *ngIf="element.pdf_link" [href]="element.pdf_link" style="font-size: 10px;"
                    download>{{'SHIPMENTDETAILS.downloadCWB_extra' | translate}}</a>
                </div>
              </div>

            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.status' | translate}} </th>
              <td mat-cell *matCellDef="let element" style="width: 40px; word-wrap: break-word;">  {{element.status}} </td>
            </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="lrColumns;sticky: true" style="font-weight: bold !important;"></tr>
          <tr mat-row *matRowDef="let row; columns: lrColumns;"></tr>
        </table>
        <div class="nodata" *ngIf="!shipment.lorry_receipt.length">
          {{'SHIPMENTDETAILS.lrNotGenerated' | translate}}
        </div>
      </div>
      <div class="body-section" [hidden]="tabIndex!=5" style="overflow: hidden;">
        <div class="estimatedDetails">
          <div *ngIf="shipment.remainingDistance != '--'">
            {{'SHIPMENTDETAILS.remaining_distance' | translate}}: {{shipment.remainingDistance}}
          </div>
          <div *ngIf="shipment.remainingTime != '--'">
            {{'SHIPMENTDETAILS.remaining_time' | translate}}: {{shipment.remainingTime}}
          </div>
        </div>
        <div class="mapButtons">
          <div class="submitButton">
            <div class="button" *ngIf="markers.gps.length"
              [ngStyle]="{'background-color': gpsMode? '#631d50':'#e4e4e4' , 'color': gpsMode? '#fff' : '#000'}"
              (click)="simMode = false; appMode = false;gpsMode = true;placeAllFavMarkers();">
              <img *ngIf="!gpsMode" src="assets/gps.svg" alt="">
              <img *ngIf="gpsMode" src="assets/gps-white.svg" alt="">
              <span class="label">GPS</span>
            </div>
          </div>
          <div class="submitButton">
            <div class="button" *ngIf="markers.sim.length"
              [ngStyle]="{'background-color': simMode? '#631d50':'#e4e4e4' , 'color': simMode? '#fff' : '#000'}"
              (click)="simMode = true; appMode = false;gpsMode = false;placeAllFavMarkers();">
              <img *ngIf="!simMode" src="assets/sim.svg" alt="">
              <img *ngIf="simMode" src="assets/sim-white.svg" alt="">
              <span class="label">Sim</span>

            </div>
          </div>
          <div class="submitButton">
            <div class="button" *ngIf="markers.app.length"
              [ngStyle]="{'background-color': appMode? '#631d50':'#e4e4e4' , 'color': appMode? '#fff' : '#000'}"
              (click)="simMode = false; appMode = true;gpsMode = false;placeAllFavMarkers();">
              <img *ngIf="!appMode" src="assets/app.svg" alt="">
              <img *ngIf="appMode" src="assets/app-white.svg" alt="">
              <span class="label">App</span>

            </div>
          </div>
        </div>

        <div class="mapPath">

          <div class="map" id="pathMap" style="height: 100%;">
          </div>
          <div class="locationList">
            <div class="locations" *ngFor="let loc of locations">
              <div class="container" (click)="viewLocation(loc);">
                <div class="date">
                  <img src="assets/map-1.svg" alt="">{{loc.date}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="body-section" [hidden]="tabIndex!=6">
        <div class="toggleViewMain">


          <div class="freightMain" [hidden]="!showGenerateFreight">
            <!-- This is generate freight -->
            <div class="selectFreight">
              <div class="wrap">
                <div class="empty">

                </div>
                <div class="center">
                  <div class="label">
                    {{'SHIPMENTDETAILS.selectFreight' | translate}}
                  </div>
                  <div class="toggle">
                    <div class="est" [ngClass]="{'selected': !freightType}"
                      (click)="freightType = 0; freightData.amount_from.type = 'estimated'; setDiscountType(discountSelected);">
                      {{'SHIPMENTDETAILS.estimated' | translate}}
                    </div>
                    <div class="actual" [ngClass]="{'selected': freightType}"
                      (click)="freightType = 1; freightData.amount_from.type = 'actual'; setDiscountType(discountSelected);">
                      {{'SHIPMENTDETAILS.actual' | translate}}
                    </div>
                  </div>
                </div>
                <div class="gstNo">
                  <div class="label">
                    {{'SHIPMENTDETAILS.gst_no' | translate}}:
                  </div>
                  <div class="value">
                    {{gstin}}
                  </div>
                </div>
              </div>
            </div>
            <!-- old Incvoice -->
            <div *ngIf="!isNewFlow">
              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.customInvoiceNumber' | translate}}
                  </div>
                  <div class="value">
                    <input class="inputField" style="width: 80%;" [(ngModel)]="reference_no">
                  </div>
                </div>
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.customReferenceDate' | translate}}
                  </div>
                  <div class="input" style="position:relative;bottom: 4px;">
                    <input type="text"  style="width: 60%" class="inputField"
                      placeholder="Date" [(ngModel)]="referenceDate" (click)="DateInput.open()"
                      [matDatepicker]="DateInput" />
                    <mat-datepicker #DateInput ></mat-datepicker>
                    <span class="material-icons dateIcon" style="position:relative;top: 6px;"> date_range </span>
                  </div>
                </div>
                </div>


              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.freightAmount' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.amount_from.comment" style="width: 80%;"
                      [placeholder]="'SHIPMENTDETAILS.comment' | translate">
                  </div>
                  <div class="value">
                    <input *ngIf="freightType" [(ngModel)]="freightamount.actual" class="inputField"
                      style="width: 80%; cursor: not-allowed;" placeholder="0.0" disabled="disabled">
                    <input *ngIf="!freightType" [(ngModel)]="freightamount.estimated" class="inputField"
                      style="width: 80%; cursor: not-allowed;" placeholder="0.0" disabled="disabled">
                  </div>
                </div>
                <div class="currency">
                  {{currencySymbol}} {{ (freightType) ? (freightamount.actual |numberFormat:freightamount.actual) :
                  (freightamount.estimated
                  |numberFormat:freightamount.estimated) }}
                </div>
              </div>

              <div class="otherCharges" style="margin-top: 10px;">
                <div class="title">
                  <span class="text">{{'SHIPMENTDETAILS.otherCharges' | translate}}</span>
                </div>
              </div>

              <div class="chargeRow">
                <div class="field" *ngIf="additional_charges.labour">
                  <div class="label">
                    {{'SHIPMENTDETAILS.porter' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.labour.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.labour.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" *ngIf="additional_charges.toll">
                  <div class="label">
                    {{'SHIPMENTDETAILS.toll' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.toll.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.toll.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" *ngIf="additional_charges.LR_charges">
                  <div class="label">
                    {{'SHIPMENTDETAILS.waybill' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.LR_charges.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.LR_charges.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field" *ngIf="additional_charges.extra_pickup">
                  <div class="label">
                    {{'SHIPMENTDETAILS.extra_pickup_point' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.extra_pickup.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.extra_pickup.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field" *ngIf="additional_charges.extra_delivery">
                  <div class="label">
                    {{'SHIPMENTDETAILS.extra_delivery_point' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.extra_delivery.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.extra_delivery.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" *ngIf="additional_charges.doc">
                  <div class="label">
                    {{'SHIPMENTDETAILS.document_charges' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.doc.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.doc.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" *ngIf="additional_charges.non_hometown_halt">
                  <div class="label">
                    {{'SHIPMENTDETAILS.outStationHalt' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.non_hometown_halt.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.non_hometown_halt.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field" *ngIf="additional_charges.insurance">
                  <div class="label">
                    {{'SHIPMENTDETAILS.insurance' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.insurance.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.insurance.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field" *ngIf="additional_charges.cancellation">
                  <div class="label">
                    {{'SHIPMENTDETAILS.cancellation' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.cancellation.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.cancellation.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field" *ngIf="additional_charges.detentionCustomer">
                  <div class="label">
                    {{'SHIPMENTDETAILS.detentionCustomer' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.detentionCustomer.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.detentionCustomer.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field" *ngIf="additional_charges.detentionPlant">
                  <div class="label">
                    {{'SHIPMENTDETAILS.detentionPlant' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.detentionPlant.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.detentionPlant.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.other_charges' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.others.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.others.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.green_tax' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.green_tax.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.green_tax.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                 <div class="field"  *ngIf="additional_charges.odc_charges">
                  <div class="label">
                    {{'SHIPMENTDETAILS.odcCharges' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.odc_charges.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.odc_charges.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" *ngIf="additional_charges.rto_fines">
                  <div class="label">
                    {{'SHIPMENTDETAILS.rtoFines' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.rto_fines.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.rto_fines.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" >
                  <div class="label">
                    {{'SHIPMENTDETAILS.unloading_charges' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.unloading_charges.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.unloading_charges.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field" >
                  <div class="label">
                    {{'SHIPMENTDETAILS.loading_charges' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.loading_charges.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.additional_charges.loading_charges.value"
                      (keyup)="calcOtherCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field">
                  <div class="label" style="width: 27%;">
                    {{'SHIPMENTDETAILS.waybill/lr' | translate}}
                  </div>
                  <div class="value" style="width: 37%;">
                    <input class="inputField" [disabled]="true" [(ngModel)]="freightData.ref_lr_id" style="width: 80%;">
                  </div>
                </div>

              </div>
              <div class="currency" style="width:99%;margin-top: 10px;margin-bottom: 10px;">
                <span style="margin-right: 100px">{{'SHIPMENTDETAILS.total_additional_charges' | translate}} :
                </span>{{currencySymbol}} {{ otherChargesTotal ? (otherChargesTotal |numberFormat:otherChargesTotal) :
                0}}
              </div>

              <!-- Deductible Charges -->
              <div class="otherCharges">
                <div class="title">
                  <span class="text">{{'SHIPMENTDETAILS.deductible_charges' | translate}}</span>
                </div>
              </div>
              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.material_damage' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.material_damage.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">
                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.material_damage.value"
                      (keyup)="calcDeductibleCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.material_missing' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.material_missing.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.material_missing.value"
                      (keyup)="calcDeductibleCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.vehicle_delay' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.vehicle_delay.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">
                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.vehicle_delay.value"
                      (keyup)="calcDeductibleCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.carton_damage' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.carton_damage.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.carton_damage.value"
                      (keyup)="calcDeductibleCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.shipper_LR_charges' | translate}}
                  </div>
                  <div class="value">
                    <!-- <input class="inputField" [(ngModel)]="freightData.deductible_charges.shipper_LR_charges.value" (keyup)="calcDeductibleCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0" > -->
                    {{currencySymbol}} {{freightData.deductible_charges.shipper_LR_charges.value}}
                  </div>
                </div>

                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.others' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.others.comment"
                      style="width: 80%;" [placeholder]="'SHIPMENTDETAILS.comment' | translate">

                  </div>
                  <div class="value">
                    <input class="inputField" [(ngModel)]="freightData.deductible_charges.others.value"
                      (keyup)="calcDeductibleCharges();twoDecimal($event);" style="width: 80%;" placeholder="0.0">
                  </div>
                </div>

                <!-- <div class="field">
                            <div class="label">
                              {{'SHIPMENTDETAILS.advance' | translate}}
                            </div>
                            <div class="value" style="width: 37%;">
                              {{currencySymbol}} {{advance_amount}}
                            </div>
                          </div> -->
              </div>
              <div class="currency" style="width:99%;margin-top: 0px;">
                <span style="margin-right: 100px">{{'SHIPMENTDETAILS.total_deductible_charges' | translate}} :
                </span>{{currencySymbol}} {{ deductibleChargesTotal ? (deductibleChargesTotal
                |numberFormat:deductibleChargesTotal)
                : 0}}
              </div>


              <div class="chargeRow">
                <div class="field" style="width: 100%;">
                  <div class="label" style="width:24%">
                    {{'SHIPMENTDETAILS.discount' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="discountAmount.comment" style="width: 90%;"
                      [placeholder]="'SHIPMENTDETAILS.comment' | translate">
                  </div>
                  <div class="value">
                    <input class="inputField" style="width: 10%; background: #e5e5e5;"
                      placeholder="{{(discountSelected.value == 'percentage') ? '%' : currencySymbol}}"
                      disabled="disabled">
                    <mat-select class="inputField" [(ngModel)]="discountSelected.name" style="width:73%">
                      <mat-option *ngFor="let item of discountTypes" (click)="setDiscountType(item);"
                        [value]="item.name">
                        {{item.name}}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="value">
                    <input class="inputField" style="width: 10%; background: #e5e5e5;"
                      placeholder="{{(discountSelected.value == 'percentage') ? '%' : currencySymbol}}"
                      disabled="disabled">
                    <input class="inputField" type="number" min="0" max="100"
                      *ngIf="(discountSelected.value == 'percentage')" [(ngModel)]="discountAmount.percentage"
                      (keyup)="calcDiscount();" style="width: 75%; margin-left: 5px;" placeholder="0.0 %">
                    <input type="number" min="0" class="inputField" *ngIf="(discountSelected.value == 'amount')"
                      [(ngModel)]="discountAmount.amount" (keyup)="calcDiscount();"
                      style="width: 75%; margin-left: 5px;" placeholder="0.0">
                  </div>
                  <div class="currency" style="width:30%;margin-top: 0px;">
                    {{currencySymbol}} {{discountTotal |numberFormat:discountTotal}}
                  </div>
                </div>
              </div>
              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.reference_no' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="reference_no" style="width: 80%;"
                      [placeholder]="'SHIPMENTDETAILS.reference_no'| translate">
                  </div>
                </div>
              </div>
              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.e_invoice_bill' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="e_invoice_bill" style="width: 80%;"
                      [placeholder]="'SHIPMENTDETAILS.e_invoice_bill'| translate">
                  </div>
                </div>
              </div>
              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.e_invoice_qr_code' | translate}}
                  </div>
                  <div class="comment">
                    <input class="inputField" [(ngModel)]="e_invoice_qr_code" style="width: 80%;"
                      [placeholder]="'SHIPMENTDETAILS.e_invoice_qr_code'| translate">
                  </div>
                </div>
              </div>

              <div class="valuesToDisplay">
                <div class="labelRow">
                  {{'SHIPMENTDETAILS.totalFreight' | translate}}
                  <span class="currency">
                    {{currencySymbol}} {{freightSubTotal |numberFormat:freightSubTotal}}
                  </span>
                  <br>
                  <span class="small">({{'SHIPMENTDETAILS.afterDiscount' | translate}})</span>
                </div>
                <div *ngIf="country == 'IN' && !URD && !GTAtoGTA">
                  <!-- FCM 12 -->
                  <div *ngIf="tax_type == 'FCM12'">
                    <div class="labelRow" *ngIf="shipment.transit_type == 'INTRA'">
                      {{'SHIPMENTDETAILS.SGST' | translate}}
                      <span class="small">({{gst / 2}}%)</span> + {{'SHIPMENTDETAILS.CGST' | translate}}
                      <span class="small">({{gst / 2}}%)</span>
                      <span class="currency">
                        {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                      </span>
                    </div>
                    <div class="labelRow" *ngIf="shipment.transit_type == 'INTER'">
                      {{'SHIPMENTDETAILS.IGST' | translate}}
                      <span class="small">({{gst}}%)</span>
                      <span class="currency">
                        {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                      </span>
                    </div>
                  </div>
                  <!-- FCM 18 -->
                  <div *ngIf="tax_type == 'FCM18'">
                    <div class="labelRow" *ngIf="shipment.transit_type == 'INTRA'">
                      {{'SHIPMENTDETAILS.SGST' | translate}}
                      <span class="small">({{gst / 2}}%)</span> + {{'SHIPMENTDETAILS.CGST' | translate}}
                      <span class="small">({{gst / 2}}%)</span>
                      <span class="currency">
                        {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                      </span>
                    </div>
                    <div class="labelRow" *ngIf="shipment.transit_type == 'INTER'">
                      {{'SHIPMENTDETAILS.IGST' | translate}}
                      <span class="small">({{gst}}%)</span>
                      <span class="currency">
                        {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                      </span>
                    </div>
                  </div>
                  <!-- RCM -->
                  <div *ngIf="tax_type == 'RCM'">
                    <div *ngIf="shipment.transit_type == 'INTRA'">
                      <div class="labelRow">
                        {{'SHIPMENTDETAILS.SGST' | translate}}
                        <span class="small">({{gst / 2}}%)</span> + {{'SHIPMENTDETAILS.CGST' | translate}}
                        <span class="small">({{gst / 2}}%)</span>
                        <span class="currency">
                          {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                        </span>
                      </div>
                      <div class="labelRow">
                        {{'SHIPMENTDETAILS.VAT_reversible' | translate}}
                        <span class="small">({{gst}}%)</span>
                        <span class="currency">
                          {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                        </span>
                      </div>
                    </div>
                    <div *ngIf="shipment.transit_type == 'INTER'">
                      <div class="labelRow">
                        {{'SHIPMENTDETAILS.IGST' | translate}}
                        <span class="small">({{gst}}%)</span>
                        <span class="currency">
                          {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                        </span>
                      </div>
                      <div class="labelRow">
                        {{'SHIPMENTDETAILS.VAT_reversible' | translate}}
                        <span class="small">({{gst}}%)</span>
                        <span class="currency">
                          {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="labelRow" *ngIf="(country == 'SA' || country == 'BR' ) && !URD && !GTAtoGTA">
                  <div class="labelRow">
                    {{'SHIPMENTDETAILS.VAT' | translate}}
                    <span class="small">({{gst}}%)</span>
                    <span class="currency">
                      {{currencySymbol}} {{vatAmount |numberFormat:vatAmount}}
                    </span>
                  </div>
                </div>
                <div class="labelRow">
                  {{'SHIPMENTDETAILS.totalFreight' | translate}}
                  <span class="currency">
                    {{currencySymbol}} {{totalAmount |numberFormat:totalAmount}}
                  </span>
                </div>
                <div class="labelRow">
                  {{'SHIPMENTDETAILS.advance' | translate}}
                  <span class="currency">
                    {{currencySymbol}} {{advance_amount |numberFormat:advance_amount}}
                  </span>
                </div>
                <div class="labelRow">
                  {{'SHIPMENTDETAILS.net_payable_amount' | translate}}
                  <span class="currency">
                    {{currencySymbol}} {{netPayableAmount |numberFormat:netPayableAmount}}
                  </span>
                </div>
              </div>
              <div class="mapButton" (click)="createFreight();">
                <div class="button">{{'SHIPMENTDETAILS.submit' | translate}}</div>
              </div>
              <div class="mapButton">
                <div class="button" (click)="cancelFreightGeneration()" style="background-color: #b1b1b1;">
                  {{'SHIPMENTDETAILS.cancel' | translate}}</div>
              </div>
            </div>
            <!-- new Incvoice -->
            <div *ngIf="isNewFlow">
              <div class="chargeRow">
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.customInvoiceNumber' | translate}}
                  </div>
                  <div class="value">
                    <input class="inputField" style="width: 80%;" [(ngModel)]="reference_no">
                  </div>
                </div>
                <div class="field">
                  <div class="label">
                    {{'SHIPMENTDETAILS.customReferenceDate' | translate}}
                  </div>
                  <div class="input" style="position: relative; bottom: 4px;">
                    <input type="text"  style="width: 62%" class="inputField"
                      placeholder="Date" [(ngModel)]="referenceDate" (click)="fromDateInput.open()"
                      [matDatepicker]="fromDateInput" />
                    <mat-datepicker #fromDateInput></mat-datepicker>
                    <span class="material-icons dateIcon" style="position:relative;top: 6px;"> date_range </span>
                  </div>
                </div>
              </div>

              <div>
                <div class="invoice_table">
                  <div>
                    <table mat-table [dataSource]="carrierInvoiceArray" class="invoice_tabe_main">
                      <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                          {{'SHIPMENTDETAILS.description_service' | translate}} </th>
                        <td mat-cell *matCellDef="let element;let i = index;" style="width: 200px;">
                          <div class="form">
                            <div *ngIf="i==0">

                              <mat-select [(value)]="freight_amount"
                                [(ngModel)]="newCarrierInvoiceArray[i].service_desc" disabled>
                                <mat-option value="freight_amount">Freight Amount</mat-option>
                              </mat-select>
                            </div>
                            <div *ngIf="i!=0">
                              <mat-select [(ngModel)]="newCarrierInvoiceArray[i].service_desc">
                                <mat-option *ngFor="let unit of getFilteredServices(i)" [value]="unit.value">
                                  {{unit.name}}
                                </mat-option>
                              </mat-select>
                            </div>

                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="hsn_code">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice"> {{'SHIPMENTDETAILS.hsn_code'
                          | translate}} </th>
                        <td mat-cell *matCellDef="let element;let i = index;" style="width: 100px;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].hsn_code">

                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="sac_code">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">{{'SHIPMENTDETAILS.sac'
                          | translate}}</th>
                        <td mat-cell *matCellDef="let element;let i = index;" style="width: 100px;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].sac_code">

                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">{{'SHIPMENTDETAILS.date' |
                          translate}}
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 100px; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <!-- <input class="inputField_invoice" style="width: 80%;" [(ngModel)]="newCarrierInvoiceArray[i].date"> -->

                            <input type="text" name="date" class="inputField_invoice" [min]="currentDate"
                              (click)="picker.open()" [matDatepicker]="picker"
                              (dateChange)="setDate(newCarrierInvoiceArray[i].carrier_date, 'change',i)"
                              style="margin-top: 2px;width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].carrier_date" />
                            <mat-datepicker #picker>
                            </mat-datepicker>

                            <!-- <input type="text" class="inputField_invoice"  [matDatepicker]="picker" [(ngModel)]="newCarrierInvoiceArray[i].date" (click)="picker.open()" />
                            <mat-datepicker #picker (closed)="setDate(newCarrierInvoiceArray[i].date, 'change',i)"></mat-datepicker> -->


                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="party_invoice">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                          {{'SHIPMENTDETAILS.party_invoice' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 100px; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].ref">
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="party_name">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">{{'SHIPMENTDETAILS.party_name'
                          | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 100px; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].party_name">
                          </div>

                        </td>
                      </ng-container>

                      <ng-container matColumnDef="way_bill">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">{{'SHIPMENTDETAILS.way_bill' |
                          translate}}
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 100px; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].quantity">
                          </div>

                        </td>
                      </ng-container>

                      <ng-container matColumnDef="weight">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                          {{'SHIPMENTDETAILS.weight_invoice' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 100px; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].weight">
                          </div>

                        </td>
                      </ng-container>

                      <ng-container matColumnDef="total_amount">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                          {{'SHIPMENTDETAILS.total_amount' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 100px; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 100%;"
                              [(ngModel)]="newCarrierInvoiceArray[i].pre_tax">
                          </div>

                        </td>
                      </ng-container>

                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                        </th>
                        <td mat-cell *matCellDef="let element;let ind = index;"
                          style="width: 50px; word-wrap: break-word;">
                          <div class="add_icon">
                            <i class="material-icons action" style="color: #e54131;"
                              *ngIf="(ind!=0 && carrierInvoiceArray.filteredData.length > 1)"
                              (click)="removeCarrierInvoiceRow(ind);">
                              cancel </i>
                            <i class="material-icons action" style="color: #104cb3;"
                              *ngIf="(ind == carrierInvoiceArray.filteredData.length-1)"
                              (click)="addCarrierInvoiceRow();">
                              add_circle_outline </i>
                          </div>

                        </td>
                      </ng-container>


                      <tr mat-header-row *matHeaderRowDef="invoiceColumns;sticky: false"
                        style="font-weight: bold !important;"></tr>
                      <tr mat-row *matRowDef="let row; columns: invoiceColumns;"></tr>
                    </table>
                  </div>
                </div>

                <div class="deductible_charges_main">
                  <div class="heading">
                    {{'SHIPMENTDETAILS.decuctible_charges' | translate}}
                  </div>
                  <button *ngIf="newDeductibleChargeArray.length==0" class="btn btn-primary"
                    (click)="addDeductibleChargeRow()">{{'SHIPMENTDETAILS.add_deductible' | translate}}</button>
                  <div class="deductible_charge" *ngIf="newDeductibleChargeArray.length>0">
                    <table mat-table [dataSource]="deductibleChargeArray" class="invoice_tabe_main">
                      <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                          {{'SHIPMENTDETAILS.description_service' | translate}} </th>
                        <td mat-cell *matCellDef="let element;let i = index;" style="width: 18%;">
                          <div class="form">
                            <mat-select [(ngModel)]="newDeductibleChargeArray[i].service_desc">
                              <mat-option *ngFor="let unit of damageList" [value]="unit.value">
                                {{unit.name}}
                              </mat-option>
                            </mat-select>
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="total_amount">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                          <!-- {{'SHIPMENTDETAILS.total_amount' | translate}} -->
                          Value
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;"
                          style="width: 15%; word-wrap: break-word;">
                          <div class="hsn_code_input">
                            <input class="inputField_invoice" style="width: 80%;"
                              [(ngModel)]="newDeductibleChargeArray[i].value">
                          </div>

                        </td>
                      </ng-container>

                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="customHeader_inoice">
                        </th>
                        <td mat-cell *matCellDef="let element;let ind = index;"
                          style="width: 50px; word-wrap: break-word;float: left;margin-top: 7px;">
                          <div class="add_icon">
                            <i class="material-icons action" style="color: #e54131;"
                              (click)="removeDeductibleChargeRow(ind);">
                              cancel </i>
                            <i class="material-icons action" style="color: #104cb3;"
                              (click)="addDeductibleChargeRow();">
                              add_circle_outline </i>
                          </div>

                        </td>
                      </ng-container>


                      <tr mat-header-row *matHeaderRowDef="deductibleColumns;sticky: false"
                        style="font-weight: bold !important;"></tr>
                      <tr mat-row *matRowDef="let row; columns: deductibleColumns;"></tr>
                    </table>
                  </div>


                </div>

              </div>
              <div class="calculation_section">
                <div>
                  <div class="calculate">
                    <button class="calculate_btn" (click)="calculate()">Calculate</button>
                  </div>
                </div>
                <div class="currency" style="width:99%;margin-bottom: 10px;">
                  <span style="margin-right: 30px">{{'SHIPMENTDETAILS.total_pre_tax' | translate}} :
                  </span>{{currencySymbol}} {{ totalPreTaxAmount ? (totalPreTaxAmount |numberFormat:totalPreTaxAmount) :
                  0}}
                </div>
              </div>



              <div class="currency" style="width:99%;margin-bottom: 10px;">
                <span style="margin-right: 58px">{{'SHIPMENTDETAILS.total_tax_amount' | translate}} :
                </span>{{currencySymbol}} {{ totalTaxAmount ? (totalTaxAmount |numberFormat:totalTaxAmount) : 0}}
              </div>
              <div class="currency" style="width:99%;margin-bottom: 10px;">
                <span style="margin-right: 85px">{{'SHIPMENTDETAILS.total_charges' | translate}} :
                </span>{{currencySymbol}} {{ totalCharges ? (totalCharges |numberFormat:totalCharges) : 0}}
              </div>



              <!-- <div class="currency" style="width:99%;margin-top: 10px;margin-bottom: 10px;">
                <span style="margin-right: 5px">{{'SHIPMENTDETAILS.total_deductible_charges' | translate}} :
                </span>{{currencySymbol}} {{ otherChargesTotal ? (otherChargesTotal |numberFormat:otherChargesTotal) : 0}}
              </div> -->

              <!-- <div class="deductible_charges_main">
                <div class="heading">
                  {{'SHIPMENTDETAILS.discount' | translate}}
                </div>
                <div class="deductible_charge">

                  <div class="grid_gap2">
                    <div class="deductible_code_input">
                      <input class="inputField_invoice" style="width: 80%;">
                    </div>
                  </div>
                  <div class="grid_gap3">
                    <div class="deductible_code_input">
                      <input class="inputField_invoice" style="width: 80%;">
                    </div>
                  </div>

                </div>
              </div>
              <div class="currency" style="width:99%;margin-top: 10px;margin-bottom: 10px;">
                <span style="margin-right: 5px">{{'SHIPMENTDETAILS.discount' | translate}} :
                </span>{{currencySymbol}} {{ otherChargesTotal ? (otherChargesTotal |numberFormat:otherChargesTotal) : 0}}
              </div> -->

              <div class="comments_amount_main">
                <div class="section_comments">
                  <div>{{'SHIPMENTDETAILS.comments' | translate}}</div>
                  <div class="comments_sec">
                    <input class="inputField_comment_sec" style="width: 80%;" [(ngModel)]="comments">
                  </div>
                </div>
                <!-- <div class="section_comments">
                  <div>{{'SHIPMENTDETAILS.carrier_invoice_amount' | translate}}</div>
                  <div class="invoice_amount">
                    <input class="inputField_amount" style="width: 80%;">
                  </div>
                </div> -->
              </div>

              <div class="bottom_sec">
                <div>
                  <div class="invoice_ref_number">
                    <div class=" reference_no_filed">
                      <div class="label">
                        {{'SHIPMENTDETAILS.reference_no' | translate}}
                      </div>
                      <div class="comment">
                        <input class="inputField" style="width: 85%;" [(ngModel)]="reference_no"
                          [placeholder]="'SHIPMENTDETAILS.reference_no'| translate">
                      </div>

                    </div>

                  </div>
                  <div class="invoice_ref_number">
                    <div class=" reference_no_filed">
                      <div class="label">
                        {{'SHIPMENTDETAILS.e_invoice_bill' | translate}}
                      </div>
                      <div class="comment">
                        <input class="inputField" [(ngModel)]="e_invoice_bill" style="width: 85%;"
                          [placeholder]="'SHIPMENTDETAILS.e_invoice_bill'| translate">
                      </div>

                    </div>

                  </div>
                  <div class="invoice_ref_number">
                    <div class=" reference_no_filed">
                      <div class="label">
                        {{'SHIPMENTDETAILS.e_invoice_qr_code' | translate}}
                      </div>
                      <div class="comment">
                        <input class="inputField" [(ngModel)]="e_invoice_qr_code" style="width: 85%;"
                          [placeholder]="'SHIPMENTDETAILS.e_invoice_qr_code'| translate">
                      </div>

                    </div>

                  </div>
                  <div class="invoice_ref_number">
                    <div class=" reference_no_filed">
                      <div class="label">
                        {{'SHIPMENTDETAILS.lr_reference_no' | translate}}
                      </div>
                      <div class="comment">
                        <input class="inputField" [(ngModel)]="ref_lr_id" style="width: 85%;"
                          [placeholder]="'SHIPMENTDETAILS.lr_reference_no'| translate">
                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div class="btn_sec">
                <!-- <div [class]="(freightInvoices.length)? 'update':'mapButton'" (click)="createFreightNew();">
                  <div class="button">{{(freightInvoices.length)?('SHIPMENTDETAILS.update' | translate):
                    ('SHIPMENTDETAILS.submit' | translate)}}</div>
                </div> -->
                <div class="split_invoice" *ngIf="(shipment.pickups.length>1)" (click)="spiltInvoice();">
                  <span class="split_invoice_btn">{{'SHIPMENTDETAILS.split_invoice' | translate}}</span>
                </div>
                <button [class]="(freightInvoices.length)? 'update':'mapButton'" (click)="createFreightNew();"
                  [disabled]="isCarrierInvoiceDisabled">
                  <div class="button">{{(freightInvoices.length)?('SHIPMENTDETAILS.update' | translate):
                    ('SHIPMENTDETAILS.submit' | translate)}}</div>
                </button>


                <div class="mapButton">
                  <div class="button" (click)="cancelFreightGenerationNew()" style="background-color: #b1b1b1;">
                    {{'SHIPMENTDETAILS.cancel' | translate}}</div>
                </div>
              </div>
            </div>


          </div>

          <div class="viewFreights" [hidden]="showGenerateFreight || showReGenerateFreight">
            <div class="subHeader">
              <span class="legend">{{'SHIPMENTDETAILS.history' | translate}}</span>
              <span class="help_icon" (click)="openVideoLink()"> <img alt="" src="assets/helpicon.svg"
                  style="width: 17px;"> </span>
              <div class="buttons">
                <div class="button" *ngIf="disableGenerateInvoice && !no_epods" (click)="showGenerateInvoice()">
                  {{'SHIPMENTDETAILS.generateFreightBtn' | translate}}
                </div>
                <div class="button" *ngIf="disableGenerateInvoice && !no_epods" (click)="showGenerateInvoiceNew()">
                  {{'SHIPMENTDETAILS.generateFreightBtn_new' | translate}}
                </div>
                <!-- <div class="button" *ngIf="freightInvoices.length && !freightInvoices[0].status" (click)="showGenerateFreight = true; initRegenerateFreight();">
                    {{'SHIPMENTDETAILS.regenerateFreightBtn' | translate}}
                  </div> -->
                <!-- <div class="button" *ngIf="freightInvoices.length && !freightInvoices[0].status" (click)="approveFreight()" style="background-color: green;">
                    {{'SHIPMENTDETAILS.approveBtn' | translate}}
                  </div> -->
              </div>
            </div>
            <table *ngIf="freightInvoices.length" mat-table [dataSource]="freightInvoices" class="lrTable">
              <ng-container matColumnDef="version_id">
                <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.slno' | translate}}</th>
                <td mat-cell *matCellDef="let element, let i = index" style="width: 20px !important;">
                  {{i+1}}
                </td>
              </ng-container>

              <ng-container matColumnDef="invoiceNo">
                <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.invoiceNo' | translate}}
                </th>
                <td mat-cell *matCellDef="let element, let i = index" style="width: 80px;">
                  <a>{{element.invoiceNo}}</a>

                  <!-- <img src="assets/preview.svg" style="width: 18px; padding-left: 10px; cursor: pointer" (click)="openInvoicePreview(element);"> -->
                </td>
              </ng-container>

              <ng-container matColumnDef="datetime">
                <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.dateTime' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="width: 80px;">
                  {{element.datetime}}
                </td>
              </ng-container>

              <ng-container matColumnDef="updated_by">
                <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.updated_by' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="width: 40px; word-wrap: break-word;">
                  {{element.updated_by}} </td>
              </ng-container>

              <ng-container matColumnDef="freight">
                <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.final_amount' |
                  translate}} ({{currencySymbol}}) </th>
                <td mat-cell *matCellDef="let element" style="width: 40px; word-wrap: break-word;">
                  {{element.final_amount}} </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.status' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="width: 40px; word-wrap: break-word;"
                  [ngClass]="{'approved': element.status == 'APPROVED','disapproved': element.status == 'DISAPPROVED','pending': element.status == 'PENDING','billed': element.status == 'BILLED'}">
                  {{element.status}}
                  <a *ngIf="element.disDoc" [href]="element.disDoc" download>
                    <mat-icon class="icons" style="color: #717171;">attach_file</mat-icon>
                  </a>

                </td>
              </ng-container>

              <ng-container matColumnDef="comment">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'SHIPMENTDETAILS.freightComment' | translate}} </th>
                <td mat-cell *matCellDef="let element" style="width: 40px; word-wrap: break-word;"> {{element.comment}}
                </td>
              </ng-container>

              <!-- <ng-container matColumnDef="view">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.freightView' | translate}}
                    </th>
                  <td mat-cell *matCellDef="let element" style="width: 40px; word-wrap: break-word;">  
                    <a [href]="element.pdf_link" download>
                      <img src="assets/download_link.svg" style="width: 18px;">
                    </a>
                     
                  </td>
                </ng-container> -->
              <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef class="customHeader">{{'SHIPMENTDETAILS.view' | translate}} </th>
                <td mat-cell *matCellDef="let element;" style="width: 40px; word-wrap: break-word;">
                  <!-- <a [href]="element.pdf_link" download>
                    <img src="assets/download_link.svg" style="width: 18px;">
                  </a> -->
                  <div *ngFor="let pdf of element.pdf_links;let i = index;">
                    <a [href]="pdf" style="font-size: 10px;" download *ngIf="i === element.pdf_links.length - 1">
                      {{'SHIPMENTDETAILS.downloadinvoice' | translate}}{{element.invoiceNo}}</a>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'SHIPMENTDETAILS.edit' | translate}}
                </th>
                <td mat-cell *matCellDef="let element, let i = index" style="width: 40px; word-wrap: break-word;">
                  <div *ngIf="!element.new_flow">
                    <img src="assets/icon-edit.svg" *ngIf="element.status == 'PENDING'"
                      style="width: 18px;cursor: pointer;"
                      (click)="showGenerateFreight = true; initRegenerateFreight(i);">
                    <span *ngIf="element.status !== 'PENDING'">N/A</span>
                  </div>
                  <div *ngIf="element.new_flow">
                    <img src="assets/icon-edit.svg" *ngIf="element.status == 'PENDING'"
                      style="width: 18px;cursor: pointer;"
                      (click)="showGenerateFreight = true; initRegenerateFreightNew(i);">
                    <span *ngIf="element.status !== 'PENDING'">N/A</span>
                  </div>

                </td>

              </ng-container>

              <tr mat-header-row *matHeaderRowDef="freightColumns;sticky: true" style="font-weight: bold !important;">
              </tr>
              <tr mat-row *matRowDef="let row; columns: freightColumns;"></tr>
            </table>

            <div class="nodata" *ngIf="warning_message && !freightInvoices.length" style="font-size: 16px;">
              {{warning_message}}
              <div class="hint">
                {{hint_message}}
              </div>
            </div>
            <div class="nodata" *ngIf="!warning_message && !freightInvoices.length">
              {{'SHIPMENTDETAILS.freightNotFound' | translate}}
              <div class="hint" *ngIf="epod_warning">
                {{epod_warning}}
              </div>
            </div>
          </div>

        </div>



      </div>
    </div>
  </div>
</div>
<ng-template #noDocs>
  <div class="noImages">
    {{'SHIPMENTDETAILS.noImages' | translate}}
  </div>
</ng-template>

<ng-template #openVideos>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'SHIPMENTDETAILS.raise_invoice' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="uploadDocsRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_URL" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template>


<!-- NEW -->